var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/goal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9.91049143,
    y1: 12.8015583,
    x2: 14.6810594,
    y2: 8.03099031,
    id: "path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path",
    points: "14.6810594 8.03099031 15.3313312 3.73782261 19.0497868 0.0834782609 19.6244989 3.08755081 22.6285714 3.66226286 18.9742271 7.38071851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9581217,9.56121839 C23.2034447,14.2819361 21.2363346,19.2642112 17.1019408,21.8609001 C12.967547,24.4575891 7.62532727,24.0660854 3.91366791,20.8943997 C0.202008553,17.722714 -1.01773565,12.5068909 0.902500248,8.01816058 C2.82273615,3.52943031 7.4373282,0.809480423 12.2944875,1.30345342",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9975096,10.9625083 C17.6148779,13.4518126 16.5849827,16.0586568 14.4329539,17.4538456 C12.2809252,18.8490344 9.48074569,18.7252784 7.46018988,17.1456792 C5.43963406,15.56608 4.64372794,12.8785431 5.4782935,10.4534081 C6.31285906,8.0282731 8.59408381,6.39967421 11.1588015,6.39801242",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGoal);
export default __webpack_public_path__ + "static/media/menu-goal.e6c0d1ab08707912fcb1838ed762cf9f.svg";
export { ForwardRef as ReactComponent };